/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menudroptitle2Inputs */

const en_menudroptitle2 = /** @type {(inputs: Menudroptitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload a photo or PDF`)
};

const de_menudroptitle2 = /** @type {(inputs: Menudroptitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foto oder PDF hochladen`)
};

/**
* | output |
* | --- |
* | "Upload a photo or PDF" |
*
* @param {Menudroptitle2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menudroptitle2 = /** @type {((inputs?: Menudroptitle2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menudroptitle2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menudroptitle2(inputs)
	return de_menudroptitle2(inputs)
});
export { menudroptitle2 as "menuDropTitle" }